export default __webpack_public_path__ + "static/media/navigation.03c5ff01.svg";